<template>
    <div>
        <div v-if="searchResults">
            <ul class="search-results">
                <li v-for="result in results"  class="search-results__item">
                    <RoomCard :data="result" :selected-year-offset="academicYearOffset"
                        :current-academic-year="currentAcademicYear" :next-academic-year="nextAcademicYear"
                        :show-remaining="showRemaining"
                         />
                </li>
            </ul>
        </div>
    </div> 
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { apiUrl } from '@utils/api.js';

const props = defineProps({
    // The list of rooms to search for
    roomIds: {
        type: Array,
        default: () => []
    },
    // The current academic year range as a string, e.g. 2023/24
    currentAcademicYear: {
        type: String,
        required: true
    },
    // The next academic year range as a string, e.g. 2024/25
    nextAcademicYear: {
        type: String,
        required: true
    },
    // Whether or not to show the "remaining rooms" label
    showRemaining: {
        type: Boolean,
        default: true
    }
});

const searchResults = ref(null);

onMounted(() => {
    doSearch();
});

const academicYearOffset = 1;

const doSearch = async () => {
    // Fetch the search results from the API
    let response;
    try {
        response = await axios.get(`${apiUrl}/search-by-ids`, {
            params: {
                ids: props.roomIds?.join(',')
            }
        });
    } catch (error) {
        console.error(error);
        return;
    }
    if (!response?.data || response.status < 200 || response.status >= 400) {
        console.error(response);
        return;
    }

    // Update the results object
    searchResults.value = response.data;
};

const results = computed(() => {
    return searchResults.value?.hits?.hits?.map((hit) => {
        return hit._source;
    });
});
</script>